/* global og */
import { getMarkup, getStyles } from '@ordergroove/offers-templates';

// import runTests from '../src/run-tests';

// runTests();

window.og_settings = {
  // object were key is product id and value is an array of plan discount
  product_discounts: {
    UD728: {
      '3_1': ['30.00', '10%', '$27.00'],
      '1_2': ['30.00', '20%', '$24.00']
    },
    UD729: [
      {
        frequency: '1_3',
        prepaidShipments: null,
        regularPrice: '$15.00',
        subscriptionPrice: '$13.50',
        discountRate: '10%'
      },
      {
        frequency: '2_3',
        prepaidShipments: null,
        regularPrice: '$15.00',
        subscriptionPrice: '$13.50',
        discountRate: '10%'
      }
    ]
  }
};

const frequencies = [
  {
    every: 1,
    period: 1
  },
  {
    every: 1,
    period: 2
  },
  {
    every: 1,
    period: 3
  },
  {
    every: 2,
    period: 3
  }
];

const settings = {
  defaultFrequency: frequencies[2],
  frequencies: [...frequencies]
};

const textCopy = {
  showTooltip: true,
  offerOptInLabel: 'Subscribe to save',
  prepaidOptInLabel: 'Prepaid Subscription',
  offerIncentiveText: 'Save {{ogIncentive DiscountPercent}} when you subscribe',
  offerOptOutLabel: 'Deliver one-time only',
  offerEveryLabel: 'Deliver every',
  prepaidShipmentsLabel: 'Number of prepaid shipments',
  offerTooltipTrigger: '[?]',
  offerTooltipContent: 'Seems this is a great subscription offering. Many fun details about this program exist.',
  optinButtonLabel: '•',
  optoutButtonLabel: '•',
  optinStatusOptedInLabel: "You're opted in!",
  optinStatusOptedOutLabel: "You're not opted in.",
  optinToggleLabel: '•',
  upsellButtonLabel: 'Add item to order on ',
  upsellButtonPrefix: '',
  upsellModalContent: 'Some upsell modal content',
  upsellModalOptInLabel: 'Subscribe',
  upsellModalOptOutLabel: 'Purchase one time',
  upsellModalTitle: 'Impulse Upsell',
  upsellModalConfirmLabel: 'Ok',
  upsellModalCancelLabel: 'Cancel',
  defaultFrequencyCopy: '(Recommended)',
  prepaidShipmentSelectAppend: 'and save {{ogPrepaid PercentageSavings}}, delivered monthly',
  prepaidExplainer: 'You will be billed {{ogPrepaid TotalPrice}} today ({{ogPrepaid PerDeliveryPrice}}/delivery)',
  subscribeToSaveExplainer: 'You will be billed {{ogPrice PayAsYouGo}} today',
  prepaidOfferIncentiveText: 'Save {{ogPrepaid PercentageSavings}} when paying upfront'
};

const offersExamples = [
  {
    name: 'empty',
    selector: 'og-offer:not([location])'
  },
  {
    name: 'built-in',
    selector: 'og-offer[location="initial"]',
    config: {
      settings: {
        ...settings,
        offerType: 'radio'
      },
      textCopy: { ...textCopy }
    }
  },
  {
    name: 'checkbox',
    selector: 'og-offer[location="initial-checkbox"]',
    config: {
      settings: {
        ...settings,
        offerType: 'toggle'
      },
      textCopy: {
        ...textCopy
      }
    }
  },
  {
    name: 'select',
    selector: 'og-offer[location="initial-select"]',
    config: {
      settings: {
        ...settings,
        offerType: 'select'
      },
      textCopy: { ...textCopy }
    }
  },
  {
    name: 'cart',
    selector: 'og-offer[location="cart"]',
    defaultPreviewMode: 'subscribed',
    config: {
      settings: {
        ...settings,
        offerType: 'cart'
      },
      textCopy: { ...textCopy }
    }
  },
  {
    name: 'side-by-side',
    selector: 'og-offer[location="side-by-side"]',
    config: {
      settings: {
        ...settings,
        offerType: 'side-by-side'
      },
      textCopy: { ...textCopy },
      styles: {
        primaryColor: 'navy',
        defaultColor: 'pink'
      }
    }
  },
  {
    name: 'read-only',
    selector: 'og-offer[location="read-only"]',
    defaultPreviewMode: 'subscribed',
    config: {
      settings: {
        ...settings,
        offerType: 'read-only'
      },
      textCopy: { ...textCopy },
      styles: {
        primaryColor: 'navy',
        defaultColor: 'pink'
      }
    }
  },
  {
    name: 'buttons',
    selector: 'og-offer[location="buttons"]',
    config: {
      settings: {
        ...settings,
        offerType: 'buttons'
      },
      textCopy: { ...textCopy },
      styles: {
        primaryColor: 'navy',
        defaultColor: 'pink'
      }
    }
  },
  {
    name: 'Prepaid PDP',
    defaultPreviewMode: 'prepaid',
    selector: 'og-offer[location="prepaid-pdp"]',
    config: {
      settings: {
        ...settings,
        offerType: 'prepaid-enabled-radio'
      },
      textCopy: { ...textCopy }
    }
  },
  {
    name: 'Prepaid Option PDP',
    defaultPreviewMode: 'prepaid',
    selector: 'og-offer[location="prepaid-option-pdp"]',
    config: {
      settings: {
        ...settings,
        offerType: 'prepaid-option'
      },
      textCopy: { ...textCopy }
    }
  },
  {
    name: 'Prepaid Cart',
    defaultPreviewMode: 'prepaid',
    selector: 'og-offer[location="prepaid-cart"]',
    config: {
      settings: {
        ...settings,
        offerType: 'prepaid-enabled-cart'
      },
      textCopy: { ...textCopy }
    }
  },
  {
    name: 'first-test',
    selector: 'og-offer[location="first-test"]',
    config: {
      settings: {
        ...settings,
        offerType: 'toggle'
      },
      textCopy: {
        ...textCopy,
        offerOptOutLabel: '1st offerOptOutLabel'
      }
    }
  },
  {
    name: 'second-test no tooltip',
    selector: 'og-offer[location="second-test"]',
    config: {
      settings: {
        ...settings,
        offerType: 'radio'
      },
      textCopy: {
        ...textCopy,
        showTooltip: false,
        offerOptOutLabel: '2st offerOptOutLabel'
      }
    }
  },
  {
    name: 'Select mode',
    selector: 'og-offer[location="select1"]',
    markup: `
<og-optin-select>
<option value="optedOut">Buy one time</option>
<option value="2w" selected>2 weeks (recomended)</option>
<option value="1m">1 month </option>
</og-optin-select>`
  },
  {
    name: 'Custom markup',
    selector: 'og-offer[location="custom1"]',
    markup: `
<og-when test="regularEligible">
<p>
<og-optout-button>Buy one time</og-optout-button>
</p>
<p>
<og-optin-button> 
  Subscribed to get <og-incentive-text from="DiscountPercent"></og-incentive-text>
</og-optin-button>
</p>
<p style="margin-left: 1.5em">
Ships every
<og-select-frequency>
  <option value="1w">1 week</option>
  <option value="2w" selected>2 weeks (recomended)</option>
  <option value="1m">1 month </option>
</og-select-frequency>
</p>
</og-when>
<og-when test="upsellEligible">
Add item to order on
<og-upsell-button>
  <a href="#">
    Add to
    <og-next-upcoming-order></og-nextupcoming-order>
  </a>
</og-upsell-button>
<og-upsell-modal>
  <div>
    This should be the offer
    <og-optout-button>Buy one time</og-optout-button>
    <br />
    <og-optin-button>Subscribed</og-optin-button>
    <p>
      Ships every
      <og-select-frequency>
        <option value="1w" selected>1 week</option>
        <option value="2w">2 weeks (recomended)</option>
        <option value="1m">1 month </option>
      </og-select-frequency>
    </p>
  </div>
  <span slot="confirm">
    <button>confirm</button>
  </span>
  <span slot="cancel">cancel</span>
</og-upsell-modal>
</og-when>`
  },
  {
    name: 'Upsell modal - radio',
    defaultPreviewMode: 'upsell',
    selector: 'og-offer[location="upsell-radio"]',
    markup: `
<og-when test="upsellEligible">
<og-upsell-button target="#upsell-radio">
  <a href="#">Add item to next order via radio</a>
</og-upsell-button>
<og-upsell-modal id="upsell-radio">
  <p>
    <og-optout-button>Ship once</og-optout-button>
  </p>
  <p>
    <og-optin-button>Ship every</og-optin-button>
    <og-select-frequency>
      <option value="1w" selected>1 week</option>
      <option value="2w">2 weeks (recomended)</option>
      <option value="1m">1 month </option>
    </og-select-frequency>
  </p>
</og-upsell-modal>
</og-when>`
  },
  {
    name: 'Upsell modal - select',
    defaultPreviewMode: 'upsell',
    selector: 'og-offer[location="upsell-select"]',
    markup: `
<og-when test="upsellEligible">
<og-upsell-button target="#upsell-select">
  <a href="#">Add item to next order via select</a>
</og-upsell-button>
<og-upsell-modal id="upsell-select">
  <og-optin-select></og-optin-select>
</og-upsell-modal>
</og-when>`
  },
  {
    name: 'Upsell modal - toggle',
    defaultPreviewMode: 'upsell',
    selector: 'og-offer[location="upsell-toggle"]',
    markup: `
<og-when test="upsellEligible">
<og-upsell-button target="#upsell-toggle">
  <a href="#">Add item to next order via toggle</a>
</og-upsell-button>
<og-upsell-modal id="upsell-toggle">
  <og-optin-toggle>
    <span>Subscribe</span>
  </og-optin-toggle>
  <span slot="confirm">I do</span>
  <span slot="cancel">Nope</span>
</og-upsell-modal>
</og-when>
  `
  },
  {
    name: 'Product-specific default frequencies',
    selector: 'og-offer[location="psdf"]',
    markup: `
<og-when test="regularEligible">
  <og-select-frequency default-text=" Most common!">
    <option value="1w">1 week</option>
    <option value="2w">2 weeks</option>
    <option value="3w">3 weeks</option>
  </og-select-frequency>
</og-when>
  `
  }
];

const componentExamples = [
  {
    name: 'og-benefit-messages',
    selector: 'og-offer[location="benefit-messages"]',
    markup: `<og-benefit-messages></og-benefit-messages>`
  },
  {
    name: 'og-optin-button',
    selector: 'og-offer[location=og-optin-button]',
    markup: `
<og-optin-button>
  I want to subscribe to this product
</og-optin-button>
  `
  },
  {
    name: 'Frequency Status',
    selector: 'og-offer[location="frequency"]',
    markup: `
<og-frequency-status>
  <span slot="not-subscribed">you are not subscribed </span>
</og-frequency-status>`
  },
  {
    name: 'Tooltip',
    selector: 'og-offer[location="tooltip-placement"]',
    markup: [
      ['top-left', 'top', 'top-right'],
      ['left', '', 'right'],
      ['bottom-left', 'bottom', 'bottom-right']
    ]
      .map(options =>
        options
          .map(
            it =>
              `<span class="tooltip-example">${
                it
                  ? `<og-tooltip placement="${it}" style="width:100%">
  <div slot="trigger">${it}</div>
  <div slot="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
</og-tooltip>`
                  : ' &nbsp; '
              }</span>`
          )
          .join('\n')
      )
      .join('<br>\n')
  }
];

const exampleTemplates = [
  ['Offers example', ...offersExamples.map((x, idx) => ({ ...x, id: idx.toString() }))],
  [
    'Individual components',
    ...componentExamples.map((x, idx) => ({ ...x, id: (idx + offersExamples.length).toString() }))
  ]
];
function updateTemplate(target) {
  const value = target.value;
  const el = document.getElementById('regular1');
  const p = JSON.parse(target.dataset.config).defaultPreviewMode || 'regular';
  el.setAttribute('preview', p);
  document.getElementById('preview-mode').value = p;

  el.setAttribute('location', value);
  window.location.hash = value;
  setTimeout(() => {
    const data = target.dataset.config;

    const style = document.getElementById('offersGlobalCss');
    style.innerHTML = '';
    style.appendChild(document.createTextNode(getStyles(JSON.parse(data).config)));

    document.getElementById('the-html').innerText = (JSON.parse(data).markup || '').trim();
    document.getElementById('the-js').innerHTML = data;
  }, 0);
}

const addOption = dropdown => (it, ix) => {
  const opt = document.createElement('option');

  opt.value = (it.selector.match(/location="?([-\w]+)"?/) || [])[1];
  opt.innerHTML = `${it.name}`;
  if (window.location.hash.substr(1) === opt.value || (!window.location.hash.substr(1) && ix === 0)) {
    opt.setAttribute('selected', true);
    setTimeout(() => updateTemplate(opt), 1);
  }
  opt.dataset.config = JSON.stringify(it, null, 4);
  // then append it to the select element
  dropdown.appendChild(opt);
};

function fillDropdown(dropdown, templates) {
  dropdown.addEventListener('change', ev => {
    updateTemplate(ev.target.querySelector(`[value="${ev.target.value}"]`));
  });

  templates.forEach((it, ix) => {
    if (Array.isArray(it)) {
      const grp = document.createElement('optgroup');
      grp.label = it.shift();
      dropdown.appendChild(grp);
      it.forEach(addOption(grp));
    } else {
      addOption(dropdown)(it, ix);
    }
  });
}

function init(templates) {
  og.offers
    .previewMode()
    .initialize('0e5de2bedc5e11e3a2e4bc764e106cf4', 'staging')
    .setTemplates(
      templates
        .flat()
        .filter(it => typeof it === 'object')
        .map(it => {
          return it.config ? { ...it, markup: getMarkup(it.config) } : it;
        })
    );

  document.getElementById('preview-mode').addEventListener('change', ev => {
    document.querySelector('og-offer').setAttribute('preview', ev.target.value);
  });
  fillDropdown(document.getElementById('choose-offer'), templates);
}

window.addEventListener('DOMContentLoaded', () => init(exampleTemplates));
